/**
 * Centralized Image Registry
 *
 * This file serves as the single source of truth for all image paths
 * across the application. All components should import images from this
 * registry rather than hard-coding public URLs.
 *
 * Benefits:
 * - Centralized management of all image paths
 * - Easy to update image locations
 * - Consistent path structure
 * - No broken image references
 */

// Brand Assets (webpack imports for optimal caching)
import logo from './images/brand/logo.png';

/**
 * Team member headshot images
 * Served from public folder for direct access
 */
export const teamImages = {
  paul: '/images/team/paul.png',
  chuck: '/images/team/chuck.png',
  jerry: '/images/team/jerry.png',
};

/**
 * Hero and large background images
 * Served from public folder for direct access
 */
export const heroImages = {
  batteryPark: '/images/hero/battery_park_city.jpg',
};

/**
 * Brand assets including logos and branded graphics
 * Uses webpack import for optimal caching
 */
export const brandAssets = {
  logo: logo,
};

/**
 * Default export for convenience
 * Allows importing all images in one statement
 */
const imageAssets = {
  teamImages,
  heroImages,
  brandAssets,
};

export default imageAssets;
